import auth from "./auth";
import api from "./api";

const SERVICE_URL = "engagement-service/";

export default {
    getChannelList() {
        return new Promise((resolve, reject) => {
            api.get(
                `${SERVICE_URL}v1/api/cms/engagement/merchant/channel/list`,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getNotificationCategories() {
        return new Promise((resolve, reject) => {
            api.get(
                `${SERVICE_URL}v1/api/cms/engagement/notification/category/list`,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getNotificationTemplates(param) {
        return new Promise((resolve, reject) => {
            api.post(
                `${SERVICE_URL}v1/api/cms/engagement/notification/template`,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    if (errors == undefined) {
                        reject(status.errors.message);
                    } else {
                        reject(errors);
                    }
                });
        });
    },
    saveNotificationTemplate(param) {
        return new Promise((resolve, reject) => {
            api.post(
                `${SERVICE_URL}v1/api/cms/engagement/notification/template/save`,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    if (errors == undefined) {
                        reject(status.errors.message);
                    } else {
                        reject(errors);
                    }
                });
        });
    },
    channelToggleUpdate(param) {
        return new Promise((resolve, reject) => {
            api.post(
                `${SERVICE_URL}v1/api/cms/engagement/merchant/channel/toggle/update`,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    if (errors == undefined) {
                        reject(status.errors.message);
                    } else {
                        reject(errors);
                    }
                });
        });
    }
};
